/*
 *
 * PortalTextBlocked
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 27-Jun-2024
*/

import PortalTextBlocked from './PortalTextBlockedContainer'

export default PortalTextBlocked
